import { ExplorePaths } from 'scripts/config/ExplorePaths'
import { SortPaths } from 'scripts/config/SortPaths'
import { langs } from 'shared/i18n/langs'

const preparePath = (path) => {
  const lang = '/:lang(' + langs.join('|') + ')?'
  return `${lang}${path}`
}

const Constants = {
  DefaultLang: 'en',
  Navigations: {
    TOGGLE_NAV_CLASS: 'toggle_nav_class',
    TOGGLE_NAV: 'toggle_nav',
    STORE_ACTIVE_NAV: 'store_active_nav'
  },
  // This requires to be here and not on the i18n folder because
  // es has a different set of categories with diffrent ids
  Categories: {
    en: {
      MUSIC: {id: '7wpc', name: 'Music', slug: 'music'},
      CELEB: {id: '9wpc', name: 'Celeb', slug: 'celeb'},
      TVFILM: {id: '21395wpc', name: 'TV/Film', slug: 'tvfilm'},
      QUIZZES: {id: '19533wpc', name: 'Quiz', slug: 'quizzes'}
    },
    es: {
      MUSIC: {id: '7wpc', name: 'Música', slug: 'musica'},
      CELEB: {id: '9wpc', name: 'Celeb', slug: 'celeb'},
      TVFILM: {id: '8wpc', name: 'TV/Cine', slug: 'tv'},
      QUIZZES: {id: '23009wpc', name: 'Pruebas', slug: 'pruebas'}
    }
  },
  AllowedEmbeds: {
    PLAYBUZZ: 'embed.playbuzz.com',
    POLLDADDY: 'secure.polldaddy.com',
    INTERACT: 'i.tryinteract.com'
  },
  Routes: {
    HOME: preparePath('/'),
    ARTICLE: preparePath('/article/:id/:slug'),
    POLLS: preparePath('/polls/:id/:slug'), // for now just an aliase for article with polls
    LISTINGS: preparePath('/:pagename(' + ExplorePaths.join('|') + ')'),
    CATEGORIES: preparePath('/:pagename(category)/:slug/:sort(' + SortPaths.join('|') + ')?'),
    TAGS: preparePath('/:pagename(tag)/:slug/:sort(' + SortPaths.join('|') + ')?'),
    FANCLUBS: preparePath('/:pagename(fanclub)/:slug/:sort(' + SortPaths.join('|') + ')?'),
    AUTHORS: preparePath('/:pagename(author)/:id/:sort(' + SortPaths.join('|') + ')?'),
    PAGES: preparePath('/:page'),
    JOB_PAGES: preparePath('/jobs/:page'),
    SEARCH: preparePath('/search'),
    PROFILE_EDIT: preparePath('/user/edit'),
    SUBMIT_TIP: preparePath('/submit-tip'),
    EMBED: preparePath('/embed/:embedtype(poll)/:id/:layout?'), // id = campaignId in fandom
    PRIVACY: preparePath('/privacy'),
    ALL: preparePath('/*')
  },
  PageTypes: {
    HOME: 'home',
    ARTICLE: 'article',
    POLLS: 'polls',
    LISTING: 'listing',
    PAGES: 'pages',
    TOPICS: 'topics',
    AUTHORS: 'authors'
  },
  ListingTypes: {
    LATEST: 'latest',
    TRENDING: 'trending',
    POPULAR: 'popular',
    CATEGORY: 'category',
    TAG: 'tag',
    FANCLUB: 'fanclub',
    AUTHOR: 'author'
  },
  ListingPageType: {
    SORTED: 'sorted',
    TAXONOMY: 'taxonomy',
    AUTHOR: 'author'
  },
  WordpressPages: {
    en: {
      about: 385157,
      terms: 386688,
      privacy: 386690,
      cookies: 1161331,
      copyright: 1161333,
      apps: 1187173,
      jobs: 904065,
      'soompi-community-guidelines': 869487,
      'our-team': 436115,
      bestfandom: 1113629
    },
    es: {
      about: 8
    }
  },
  // Sponsored Item
  SponsoredItem: {
    id: '59873wpt', // can be a category or tag id
    type: 'tag', // replace accordingly 'category' or 'tag'
    maxAge: false // (60 * 60 * 24) 1 day, set to false if not using
  },
  WordpressJobPages: {
    'editorial-intern': 904077,
    'assistant-editor': 904071,
    'features-writer': 904081
  },
  MetaDefaults: {
    Description: 'Breaking K-Pop and K-Drama News, Exclusives, and Videos',
    StaticStructHome: {
      en: `{
        "@context" : "http://schema.org",
        "@type"    : "Organization",
        "name"     : "Soompi",
        "email"    : "help@soompi.com",
        "url"      : "https://www.soompi.com",
        "sameAs" : [
          "https://twitter.com/soompi",
          "https://www.facebook.com/soompi",
          "https://www.youtube.com/user/soompi",
          "https://www.instagram.com/soompi",
          "https://soompi.tumblr.com",
          "https://plus.google.com/+SoompiKpop",
          "https://en.wikipedia.org/wiki/Soompi"
        ]
      }`,
      es: `{
        "@context" : "http://schema.org",
        "@type"    : "Organization",
        "name"     : "Soompi",
        "email"    : "help@soompi.com",
        "url"      : "https://www.soompi.com/es",
        "sameAs" : [
          "https://twitter.com/soompispanish",
          "https://www.facebook.com/soompispanish",
          "https://www.youtube.com/user/soompi",
          "https://www.instagram.com/soompispanish",
          "https://soompi.tumblr.com",
          "https://plus.google.com/+SoompiKpop",
          "https://en.wikipedia.org/wiki/Soompi"
        ]
      }`
    },
    StaticStructSearch: {
      en: `{
        "@context" : "http://schema.org",
        "@type"    : "WebSite",
        "url"      : "https://www.soompi.com",
        "name"     : "Soompi",
        "potentialAction" : {
          "@type"       : "SearchAction",
          "target"      : "https://www.soompi.com/search?query={query}",
          "query-input" : "required name=query"
        }
      }`,
      es: `{
        "@context" : "http://schema.org",
        "@type"    : "WebSite",
        "url"      : "https://www.soompi.com/es",
        "name"     : "Soompi",
        "potentialAction" : {
          "@type"       : "SearchAction",
          "target"      : "https://www.soompi.com/es/search?query={query}",
          "query-input" : "required name=query"
        }
      }`
    }
  },
  EU: ['at', 'be', 'bg', 'cy', 'cz', 'de', 'dk', 'ee', 'es', 'fi', 'fr',
    'gb', 'gr', 'hr', 'hu', 'ie', 'it', 'lt', 'lu', 'lv', 'mt', 'nl',
    'pl', 'pt', 'ro', 'se', 'si', 'sk', 'xx'],
  CookieConsentDefault: {
    analytics: true,
    social: true,
    advertising: true
  },
  CookieConsentName: 'cookie-consent',
  Search: {
    SEARCH_INPUT: 'SEARCH_CALLBACK'
  },
  VideoHostRegex: {
    YOUTUBE: /^https?:\/\/www.youtube.com\/embed\/[A-Za-z0-9]+/,
    VIKI: /^https?:\/\/www.viki.com\/player\/[A-Za-z0-9]+/
  },
  Spotlight: {
    en: {id: '12501wpt', slug: 'soompi-spotlight'},
    es: {id: '29633wpt', slug: 'soompi-originales'}
  },
  Profile: {
    UPDATE_INFO_SUCCESS: 'update_info_success',
    UPDATE_INFO_FAILURE: 'update_info_failure'
  },
  Auth: {
    OK: 'OK',
    NO: 'NO',
    ERR: 'Error'
  },
  disqusLangs: {
    es: 'es_ES',
    en: 'en_US'
  },
  WatchNow: {
    en: {
      tag: {
        id: '59305wpc', // Options: video (59305wpc), video-spotlight (59597wpt)
        type: 'category'
      },
      category: {
        id: '59305wpc',
        linktype: 'category',
        slug: 'video'
      }
    },
    es: {
      tag: {
        id: '34637wpt', // Options: video (35469wpc), video-spotlight (34637wpt)
        type: 'tag'
      },
      category: {
        id: '35469wpc',
        linktype: 'category',
        slug: 'video'
      }
    }
  },
  Poll: {
    Layouts: {
      DEFAULT: 'default',
      TILED: 'tiled'
    },
    PatternPartial: '[-soompi-poll-',
    RegEx: /\[-soompi-poll-([a-z0-9]+)?[-]?(\d+vtc)-\]/
  }
}

export default Constants



// WEBPACK FOOTER //
// ./assets/js/base/Constants.js